import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { ClubGoal, FiscalYear, ClubGoalCollection } from '../../entities/';
import { HttpClient } from './http-client.service';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';
import { Settings } from '../../settings';

@Injectable()
export class ClubGoalService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly clubGoalBaseUrl:string = `${Settings.apiUrl}/v1/ClubGoals`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  public getClubGoalsByClubAndYearId(clubId:string, fiscalYearId:number):Promise<ClubGoal[]>{
    let oDataBuilder:ODataBuilder = new ODataBuilder(ClubGoalService.clubGoalBaseUrl);

    oDataBuilder
      .filter("ClubId", ODataComparer.Equals, clubId)
      .filter("FiscalYearId", ODataComparer.Equals, fiscalYearId)
      .expand("Goal")
      //TODO:  Investigate whether or not this is needed as it adds more to the payload than it really needs
      .expand("Club")
      .orderBy("Goal/GoalCategory/SortOrder")
      .orderBy("Goal/SortOrder");

    let clubGoalUrl:string = oDataBuilder.toString();

    return this.http.get(clubGoalUrl)
              .toPromise()
              .then(response => response.json().value);
  }

  public getClubGoalsForPreviousYears(clubGoal:ClubGoal, selectedFiscalYear:FiscalYear):Promise<ClubGoal[]>{
    let oDataBuilder:ODataBuilder = new ODataBuilder(ClubGoalService.clubGoalBaseUrl);

    oDataBuilder
      .filter("ClubId", ODataComparer.Equals, clubGoal.ClubId)
      .filter("GoalId", ODataComparer.Equals, clubGoal.GoalId)
      .filter("FiscalYear/StartDate", ODataComparer.LessThan, selectedFiscalYear.StartDate)
      .expand("FiscalYear")
      .top(clubGoal.Goal.NumYearsHistoricalData)
      .orderBy("FiscalYear/StartDate", true);

    let clubGoalUrl:string = oDataBuilder.toString();

    return this.http.get(clubGoalUrl)
              .toPromise()
              .then(response => {
                let clubGoals = response.json().value;

                //TODO:  Replace this with proper deserialization
                clubGoals.forEach(clubGoal => {
                  if(clubGoal.FiscalYear){
                    clubGoal.FiscalYearName = clubGoal.FiscalYear.Name;
                    return;
                  }
                  clubGoal.FiscalYearName = null; 
                });

                return clubGoals;
              });
  }

  public getAllTimeHighClubGoal(clubGoal:ClubGoal):Promise<ClubGoal>{
    let oDataBuilder:ODataBuilder = new ODataBuilder(ClubGoalService.clubGoalBaseUrl);

    oDataBuilder
      .filter("ClubId", ODataComparer.Equals, clubGoal.ClubId)
      .filter("GoalId", ODataComparer.Equals, clubGoal.GoalId)
      .top(1)
      .orderBy("Progress", true);

    let clubGoalUrl:string = oDataBuilder.toString();

    return this.http.get(clubGoalUrl)
              .toPromise()
              .then(response => {
                let allTimeHighClubGoals = response.json().value;
                if(allTimeHighClubGoals && allTimeHighClubGoals.length){
                  let allTimeHighClubGoal = allTimeHighClubGoals[0];

                  return allTimeHighClubGoal;
                }
                return null;
              });
  }

  public saveClubGoal(clubGoal:ClubGoal):Promise<ClubGoal>{
    //Create a shallow copy so that I can delete AllTimeHigh without deleting it from the original
    //AllTimeHigh will break serialization in C#
    let clubGoalCopy = Object.assign({}, clubGoal);
    delete clubGoalCopy.AllTimeHigh;

    if(clubGoalCopy.ClubGoalId){
      //Udpate
      let clubGoalUrl:string = `${Settings.apiUrl}/v1/ClubGoals(${clubGoalCopy.ClubGoalId})`;
      return this.http.put(clubGoalUrl, JSON.stringify(clubGoalCopy), this.options)
                .toPromise()
                .then(response => {
                  return clubGoal;
                });
    }else{
      //Insert
      let clubGoalUrl:string = `${Settings.apiUrl}/v1/ClubGoals`;
      return this.http.post(clubGoalUrl, JSON.stringify(clubGoalCopy), this.options)
                .toPromise()
                .then(response => response.json().value);
    }
  }

  public deleteClubGoal(clubGoal:ClubGoal):Promise<ClubGoal>{
    let clubGoalUrl:string = `${Settings.apiUrl}/v1/ClubGoals(${clubGoal.ClubGoalId})`;
      return this.http.delete(clubGoalUrl, this.options)
                .toPromise()
                .then(response => {
                  return clubGoal;
                });
  }

  public AddAndDeleteClubGoals(goalsToAdd:ClubGoal[], goalsToDelete:ClubGoal[]):Promise<Response>{
    let clubGoalUrl:string = `${Settings.apiUrl}/api/ClubGoals/Many`;
    let collection:ClubGoalCollection = new ClubGoalCollection(goalsToAdd, goalsToDelete);

    return this.http.post(clubGoalUrl, JSON.stringify(collection), this.options)
                .toPromise()
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/club-goal.service.ts